import React from "react";
import reactDom from "react-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { CrossIcon } from "wm-graphics";
import getTestIDs from "../../../utils/getTestIDs";

import "./Slideout.scss";

export const testIDs = getTestIDs();

export class Slideout extends React.Component {
  static defaultProps = {
    isVisible: false,
    orientation: "left",
    closeOnOutsideClick: true,
    outsideClickEnabled: true,
  };

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Allows the ability to temporailiy disable outside click close */
    outsideClickEnabled: PropTypes.bool,
    /** The side of the screen the Slideout comes out of */
    orientation: PropTypes.oneOf(["left", "right"]),
    /** Conditional to determine whether slideout closes on outside click */
    closeOnOutsideClick: PropTypes.bool,
    /** The node to attach the Slideout onto */
    location: PropTypes.object.isRequired,
    /** Whether the Slideout is open or closed */
    isVisible: PropTypes.bool,
    /** Contents of the Slideout */
    children: PropTypes.node,
    /** A callback function for when the close button is clicked */
    onCloseClick: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      isVisible: props.isVisible,
    };

    this.fieldRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { isVisible } = this.props;
    if (isVisible !== prevProps.isVisible) {
      this.setIsVisible(isVisible);
    }
  }

  onCloseClick = () => {
    const { isVisible } = this.state;
    const { onCloseClick } = this.props;

    this.setIsVisible(!isVisible);
    if (onCloseClick) {
      onCloseClick();
    }
  };

  onCloseKeyDown = (event) => {
    if (event.key === "Enter") {
      this.onCloseClick();
    }
  };

  handleClickOutside = (event) => {
    const { onCloseClick, outsideClickEnabled } = this.props;

    if (!outsideClickEnabled) {
      return;
    }

    if (this.fieldRef && !this.fieldRef.current.contains(event.target)) {
      if (onCloseClick) {
        onCloseClick();
      }
      this.setIsVisible(false);
    }
  };

  setIsVisible = (newIsVisible) => {
    const { closeOnOutsideClick } = this.props;

    if (newIsVisible && closeOnOutsideClick) {
      document.addEventListener("mousedown", this.handleClickOutside);
    } else {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }

    this.setState({ isVisible: newIsVisible });
  };

  render() {
    const { isVisible } = this.state;
    const { children, className, location, orientation } = this.props;

    const slideoutClass = classNames(
      "Slideout",
      orientation,
      isVisible ? "open" : "closed",
      className
    );

    return reactDom.createPortal(
      <div
        className={slideoutClass}
        ref={this.fieldRef}
        data-testid={testIDs.slideout}
      >
        <div
          className="Slideout__close"
          role="button"
          tabIndex={0}
          onClick={this.onCloseClick}
          onKeyDown={this.onCloseKeyDown}
          data-testid={testIDs.closeButton}
        >
          <CrossIcon height="16" width="16" />
        </div>
        {children}
      </div>,
      location
    );
  }
}

export default Slideout;
